<template>
  <div
    class="dui-progress-bar"
    :class="[ vm.colorClass, valueSide ]"
  >
    <span
      class="progress"
      :style="{ 'width': value + '%' }"
    />
    <span
      v-if="valueSide === 'right'"
      class="progress-label-and-value"
    >
      <span
        v-if="numVotes !== null"
        class="num-votes"
      >{{ numVotes }} {{ numVotes | duiPluralize('vote', 'votes', '') }}</span>
      <span
        class="progress-label"
        :title="label"
      >{{ label }}</span>
      <span class="progress-value">{{ value }}%</span>
    </span>
    <span
      v-else
      class="progress-label-and-value"
    >
      <span class="progress-value">{{ value }}%</span>
      <span
        class="progress-label"
        :title="label"
      >{{ label }}</span>
      <span
        v-if="numVotes !== null"
        class="num-votes"
      >{{ numVotes }} {{ numVotes | duiPluralize('vote', 'votes', '') }}</span>
    </span>
  </div>
</template>

<script>
import coloredComponent from '@dui/mixins/colored-component';

export default {
  mixins: [
    coloredComponent,
  ],
  props: {
    label: {
      type: String,
      default: null,
    },
    numVotes: {
      type: Number,
      default: null,
    },
    value: {
      type: Number,
      default: 0,
      validator: function (value) {
        return value >= 0 && value <= 100;
      },
    },
    valueSide: {
      type: String,
      default: 'left',
      validator: function (value) {
        return [
          'left',
          'right',
        ].indexOf(value) !== -1;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

@mixin makeColorProgressBar($color,
                            $color-variation,
                            $text-color,
                            $text-color-variation,
                            $bg-color: getColor($white, base)) {

  background-color: $bg-color;

  .progress {
    background-color: getColor($color, $color-variation);
  }

  .progress-label-and-value {
    color: getColor($text-color, $text-color-variation);
  }
}

.dui-progress-bar {
  border: $border-width-base solid getColor($grey);
  border-radius: $border-radius-base;
  display: flex;
  height: $_4em;
  overflow: hidden;
  position: relative;

  .progress,
  .progress-label-and-value {
    position: absolute;
    z-index: 1;
  }

  .progress {
    height: 100%;
    left: 0;

    @include transition((
      width
    ), $transition-time-slow);
  }

  .progress-label-and-value {
    display: flex;
    font-weight: $base-weight-bold;
    left: 0;
    padding: 0 $_1em;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100% - #{ $_2em });

    @include screenMoreThan(sm) {
      padding: 0 $_2em;
      width: calc(100% - #{ $_4em });
    }

    .progress-label {
      flex: 1;
      margin: 0 $_1em;

      @include ellipsis();
    }

    .num-votes,
    .progress-value {
      flex: 0 1 auto;
    }

    .num-votes {
      font-weight: normal;
    }
  }

  &.right {
    .progress {
      left: initial;
      right: 0;
    }

    .progress-label-and-value {
      right: $_2em;
    }
  }

  @include makeColorProgressBar($yellow, fade, $black, base);
  &.color-black  { @include makeColorProgressBar($black, base, $white, base); }
  &.color-blue   { @include makeColorProgressBar($blue, fade, $blue, medium); }
  &.color-grey   { @include makeColorProgressBar($grey, fade, $black, fade); }
  &.color-red    { @include makeColorProgressBar($red, fade, $red, medium); }
  &.color-sand   { @include makeColorProgressBar($sand, fade, $black, base); }
  &.color-white  { @include makeColorProgressBar($white, base, $black, base, transparent); }
  &.color-yellow { @include makeColorProgressBar($yellow, fade, $black, base); }
}
</style>
